module.exports = __webpack_public_path__ + "static/img/cover 1.9825bb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue14/cover 1.jpg
// module id = nWQ0
// module chunks = 7